import _ from 'lodash'

import config from '@config'

import {
    ASSIGNED_TENDERS_LOAD_DETAILS_DATA,
    ASSIGNED_TENDERS_LOAD_DETAILS_DATA_REQUEST,
    ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_TRUE,
    ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FALSE,
    ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FAILED,
    ASSIGNED_TENDERS_DETAILS_TABLE_DATA_RECEIVED,
} from './constants'

export const loadDetailsData = (module, block, entId, level, tenderId) => ({
    type: ASSIGNED_TENDERS_LOAD_DETAILS_DATA,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
    },
})

export const loadTableDataRequest = (module, block, entId, level, lang, token, tenderId, queryParams) => ({
    type: ASSIGNED_TENDERS_LOAD_DETAILS_DATA_REQUEST(entId, tenderId),
    payload: {
        uri: _.get(config, `api.${module}.${block}.tables.publishedTendersDetails.uri`),
        qs: {
            ...queryParams,
            entId,
            lang,
            token,
            level,
            procurementType: 'pub',
            procurementId: tenderId,
        },
        uriParams: {
            entId,
            lang,
        },
        headers: {
            'X-Token': token,
        },
    },
})

export const detailsTableLoadingTrue = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_TRUE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const detailsTableLoadingFalse = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FALSE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const detailsTableLoadingFailed = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FAILED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const detailsTableDataReceived = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_DETAILS_TABLE_DATA_RECEIVED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})
